module.exports = __webpack_public_path__ + "media/images/embolt-icon-098196b83168b50ddcbe1faf8ef3212d.svg";